import { useT } from "@/lib/i18n";

// tabs: 1..5 and "total"
export default function SetTabs({ value, onChange, showTotal = true, size = "md", scores = null }) {
  const { t } = useT();
  const base =
    size === "lg"
      ? "h-12 px-4 sm:px-5 text-sm sm:text-base"
      : "h-10 px-3 sm:px-4 text-xs sm:text-sm";
  const items = [1, 2, 3, 4, 5].map((n) => ({ key: n, label: `SET ${n}` }));
  if (showTotal) items.push({ key: "total", label: t("dv_match") });
  return (
    <div className="inline-flex rounded-2xl bg-slate-800/60 p-1 gap-1" data-testid="dv-set-tabs">
      {items.map((it) => {
        const active = value === it.key;
        return (
          <button
            key={it.key}
            type="button"
            onClick={() => onChange(it.key)}
            data-testid={`dv-set-tab-${it.key}`}
            className={`dv-btn ${base} whitespace-nowrap rounded-xl font-heading font-extrabold tracking-wide ${
              active
                ? it.key === "total"
                  ? "bg-sunset text-white"
                  : "bg-white text-slate-900"
                : "text-slate-300 hover:text-white hover:bg-slate-700"
            }`}
          >
            {it.label}
            {scores && it.key !== "total" && scores[String(it.key)] && (
              <span className={`block text-[10px] leading-none mt-0.5 ${active ? "text-slate-500" : "text-slate-400"}`} data-testid={`dv-set-score-${it.key}`}>
                {scores[String(it.key)][0]}-{scores[String(it.key)][1]}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
